import { render } from "./HelloWorld.vue?vue&type=template&id=0dac05f2&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=0dac05f2&scoped=true&lang=scss"

import exportComponent from "/home/gruxxki/dev_web/POC/tombo-random/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dac05f2"]])

export default __exports__